import React, { useState } from "react";
import { createInternalUserService } from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";
import { checkUserExists } from "../../../services/Auth";

const MODULES = [
  { key: "dashboard", label: "Dashboard" },
  { key: "customers", label: "Customers" },
  { key: "warehouse", label: "Warehouse" },
  { key: "discount", label: "Discount" },
  { key: "module_settings", label: "Module Settings" },
  { key: "products", label: "Products" },
  { key: "inventory", label: "Inventory" },
  { key: "accounting", label: "Accounting" },
  { key: "comments", label: "Comments" },
  { key: "all_users", label: "All Users" },
  { key: "reports", label: "Reports" },
  { key: "telecalling", label: "TeleCalling" },
  { key: "orders", label: "Orders" },
];

const initialFormState = {
  username: "",
  // clientid: "",
  first_name: "",
  last_name: "",
  usertype: "",
  email: "",
  mobile: "",
  password: "",
  is_active: false,
};

const InternalUserCreation = () => {
  const [form, setForm] = useState(initialFormState);

  const [selectedModules, setSelectedModules] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    // MOBILE VALIDATION
    if (name === "mobile") {
      const cleanValue = value.replace(/\D/g, "");

      if (cleanValue.length === 10) {
        validateUserField(cleanValue, "mobile",);
      }

      setForm({ ...form, mobile: cleanValue });
      return;
    }

    // EMAIL VALIDATION
    if (name === "email") {
      const emailValue = value.trim();

      // basic email format check before API call
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(emailValue)) {
        validateUserField(emailValue, "email",);
      }

      setForm({ ...form, email: emailValue });
      return;
    }

    // OTHER FIELDS
    setForm({ ...form, [name]: value });
  };
  const DESIGNATIONS = [
    "Admin",
    "Digital Manager",
    "Sales",
    "Telemrk",
    "Accounts",
    "Warehouse",
    "Marketing Manager"
  ];
  const validateUserField = async (value, field) => {
    if (!value) return Promise.resolve(); // skip empty fields

    try {
      const res = await checkUserExists({ param: value });

      // Adjust this according to your API response
      // For example: res.data.exists = true if user exists
      if (res.status == 200) {
        if (field === "mobile") {
          setMobileError("User already exists with this mobile");
        }
        if (field === "email") {
          setEmailError("User already exists with this email");
        } return Promise.reject(`${field} already exists`);
      }
      else {
        if (field === "mobile") {
          setMobileError("");
        }
        if (field === "email") {
          setEmailError("");
        }
      }
      return Promise.resolve();
    } catch (err) {
      if (err?.response?.status === 400 || err?.response?.status === 409) {
        return Promise.reject(`${field} already exists`);
      }
      return Promise.reject("Unable to validate. Try again later.");
    }
  };

  const toggleModule = (key) => {
    setSelectedModules((prev) =>
      prev.includes(key)
        ? prev.filter((m) => m !== key)
        : [...prev, key]
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedModules.length === 0) {
      showSnackbar("error", "At least one module must be selected");
      return;
    }

    const payload = {
      ...form,
      username:form.email,
      is_active: form.is_active ? 1 : 0,
      module_assign: selectedModules.join(","),

      date_joined: new Date().toISOString(),
    };
    console.log(payload)
    try {
      console.log('paylad', payload)
      setLoading(true);
      const res = await createInternalUserService(payload);

      // Handle both status codes and response messages
      if (res?.status === 200 || res?.status === 201) {
        showSnackbar("success", res);
        setForm(initialFormState)
      }
    } catch (err) {
      console.error(err);

      // Show API error message if available
      const errorMsg =
        err?.response?.data?.msg ||
        err?.message ||
        "Failed to create user";
      showSnackbar("error", errorMsg);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container mb-5">
      <h4 className="text-center text-success mb-4">
        Internal-User-Creation
      </h4>

      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div className="row">
          {/* <div className="col-md-3">
            <label style={{ color: "black" }}>Client ID</label>
            <input
              name="clientid"
              className="form-control"
              value={form.clientid}
              onChange={handleChange}
              required
            />
          </div> */}

          {/* <div className="col-md-3">
            <label style={{ color: "black" }}>UserName</label>
            <input
              name="username"
              className="form-control"
              value={form.username}
              onChange={handleChange}
              required
            />
          </div> */}

          <div className="col-md-4">
            <label style={{ color: "black" }}>First Name</label>
            <input
              name="first_name"
              className="form-control"
              value={form.first_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label style={{ color: "black" }}>Last Name</label>
            <input
              name="last_name"
              className="form-control"
              value={form.last_name}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="row mt-3">
          <div className="col-md-6">
            <label style={{ color: "black" }}>Mobile Number</label>
            <input
              name="mobile"
              className="form-control"
              value={form.mobile}
              onChange={handleChange}
              required
              maxLength={10}         // limits input to 10 digits
              pattern="\d{10}"       // regex: exactly 10 digits
              title="Mobile number must be 10 digits"
            />
            {mobileError && (
              <div className="text-danger" style={{ fontSize: "12px" }}>
                {mobileError}</div>)}
          </div>


          <div className="col-md-6">
            <label style={{ color: "black" }}>Password</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                value={form.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
              >
                👁
              </button>
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="row mt-3">
          <div className="col-md-6">
            <label>Designation</label>
            <select
              name="usertype"
              className="form-control"
              value={form.usertype}
              onChange={handleChange}
              required
            >
              <option value="">Select Designation</option>
              {DESIGNATIONS.map((designation) => (
                <option key={designation} value={designation}>
                  {designation}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <label>Email ID</label>
            <input
              name="email"
              type="email"
              className="form-control"
              value={form.email}
              onChange={handleChange}
              required
              pattern="[a-z0-9._%+-]+@gmail\.com$"
              title="example@gmail.com"
            />
            {emailError && (
              <div className="text-danger" style={{ fontSize: "12px" }}>
                {emailError}
              </div>
            )}
          </div>
        </div>

        {/* Active */}
        <div className="form-check mt-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="is_active"
            checked={form.is_active}
            onChange={(e) =>
              setForm({ ...form, is_active: e.target.checked })
            }
          />
          <label className="form-check-label" htmlFor="is_active">
            Active
          </label>
        </div>

        {/* Modules */}
        <div className="row mt-4">
          {MODULES.map((m) => (
            <div className="col-md-4" key={m.key}>
              <div className="form-check" style={{ color: "black" }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedModules.includes(m.key)}
                  onChange={() => toggleModule(m.key)}
                />
                <label className="form-check-label">{m.label}</label>
              </div>
            </div>
          ))}
        </div>

        <button
          type="submit"
          className="btn btn-success mt-4"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default InternalUserCreation;
